import React, { useState } from 'react';

import classnames from 'classnames';

import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import Chip from '@lotlinx-aws/sparky-component-library/Sparky/Chip';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import { COLOR } from '@lotlinx-aws/sparky-component-library/Sparky/styles/vars';
import { EditIcon } from '@lotlinx-aws/sparky-component-library/Sparky/SVGs/EditIcon';
import { LocateIcon } from '@lotlinx-aws/sparky-component-library/Sparky/SVGs/LocateIcon';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import styles from './PinCard.module.scss';

export interface PinListProps {
  pinName: string;
  editable?: boolean;
  disable?: boolean;
  showDoneEditingButton?: boolean;
  state?: 'Modified' | 'New';
  onClick(): void;
  onMouseEnter(): void;
  onMouseLeave(): void;
  onSavePin?(e: React.MouseEvent): void;
}

/**
 * PinList
 */
export default function PinCard({
  pinName,
  editable = true,
  disable = false,
  showDoneEditingButton = false,
  state,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onSavePin,
}: PinListProps) {
  const [showEditButton, setShowEditButton] = useState(false);
  return (
    <div
      data-disabled={disable}
      className={classnames([styles.pinCard, showDoneEditingButton && styles.editingPinCard])}
      onClick={() => {
        if (!disable) {
          onClick();
        }
      }}
      onMouseEnter={() => {
        if (!disable) {
          editable && setShowEditButton(true);
          !showDoneEditingButton && onMouseEnter();
        }
      }}
      onMouseLeave={() => {
        if (!disable) {
          editable && setShowEditButton(false);
          !showDoneEditingButton && onMouseLeave();
        }
      }}
    >
      <LocateIcon color={disable ? COLOR.SPARKY_GREY_300 : 'black'} />
      <Text size='14' fontWeight={7} className={classnames([disable && styles.disabledText])}>
        {pinName}
      </Text>
      {state && (
        <Chip variant='filled' color={state === 'New' ? 'blue' : 'yellow'}>
          {state}
        </Chip>
      )}

      {showDoneEditingButton && (
        <Button
          onClick={onSavePin}
          contentClassName={styles.doneEditingButton}
          className={styles.editButton}
        >
          Done editing
        </Button>
      )}

      {showEditButton && !disable && !showDoneEditingButton && (
        <IconButton
          aria-label='edit pin'
          size='md'
          disabled={disable}
          className={styles.editButton}
        >
          <EditIcon />
        </IconButton>
      )}
    </div>
  );
}
